module.exports = __webpack_public_path__ + "img/product-img1.ebfe7151.png";